import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

import { faTrashAlt } from "@fortawesome/free-regular-svg-icons/faTrashAlt";

import FontAwesomeIcon from "components/FontAwesomeIcon";

type MuteButtonProps = {
  onClick?: () => void;
  muted?: boolean;
};

const MuteButton = ({ onClick, muted }: MuteButtonProps) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{muted ? "Click to unmute" : "Click to mute"}</Tooltip>}
    >
      <span>
        <FontAwesomeIcon
          className={twMerge(
            "cursor-pointer text-[17px] flex-2 text-shady-gray hover:text-bearish-red"
          )}
          onClick={onClick}
          icon={faTrashAlt}
        />
      </span>
    </OverlayTrigger>
  );
};

export default MuteButton;
